import { render, staticRenderFns } from "./footer-resolution.vue?vue&type=template&id=df734cd0&scoped=true"
import script from "./footer-resolution.vue?vue&type=script&lang=js"
export * from "./footer-resolution.vue?vue&type=script&lang=js"
import style0 from "./footer-resolution.vue?vue&type=style&index=0&id=df734cd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df734cd0",
  null
  
)

export default component.exports